module.exports = __webpack_public_path__ + "static/media/226.95665916.webp";